import { z } from 'zod';
import { PAYROLL_ITEM_CATEGORY_TAB_KEYS } from '@/features/engine-shared/atom-list/payroll-item-list-tab';

/** 給与計算体系・給与計算 unit 一覧の URL 検索（scheduled タブ付き）。 */
export const PayrollStructureUnitListSearchSchema = z.object({
  lifecycleTab: z.enum(['all', 'draft', 'applied', 'archived', 'scheduled']).default('applied'),
  countryCode: z.string().default('all'),
  /** 名称・説明に対するフリーテキスト絞り込み。 */
  freeText: z.string().catch(''),
  /** 利用給与計算項目の管理タグ絞り込み（いずれかのタグを含む unit に一致）。 */
  managementTags: z.array(z.string()).catch([]),
  /**
   * 出力項目カテゴリの絞り込み（給与計算単位一覧のサイドパネル）。
   * 給与計算体系一覧はこのサイドパネルを持たないため、既定値のまま使わない。
   */
  categoryTab: z.enum(PAYROLL_ITEM_CATEGORY_TAB_KEYS).default('earnings'),
  pageSize: z.number().default(50),
  pageIndex: z.number().default(0)
});
export type PayrollStructureUnitListSearchParams = z.infer<typeof PayrollStructureUnitListSearchSchema>;